var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "width": "94%",
      "border": "1px #eaeaea solid",
      "margin-left": "3%",
      "padding-bottom": "20px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "height": "40px",
      "background-color": "#fafafa",
      "border-bottom": "1px #eaeaea solid"
    }
  }, [_c('span', {
    staticStyle: {
      "line-height": "40px",
      "margin-left": "20px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.projectPost.post_name))])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "506px",
      "overflow-y": "scroll"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "model": _vm.projectPost,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "人数:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.projectPost.person_count),
      callback: function($$v) {
        _vm.$set(_vm.projectPost, "person_count", $$v)
      },
      expression: "projectPost.person_count"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "年龄:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.projectPost.age_start),
      callback: function($$v) {
        _vm.$set(_vm.projectPost, "age_start", $$v)
      },
      expression: "projectPost.age_start"
    }
  }), _vm._v("\n                    —\n                    "), _c('el-input', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.projectPost.age_end),
      callback: function($$v) {
        _vm.$set(_vm.projectPost, "age_end", $$v)
      },
      expression: "projectPost.age_end"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别:"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.projectPost.sex),
      callback: function($$v) {
        _vm.$set(_vm.projectPost, "sex", $$v)
      },
      expression: "projectPost.sex"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.projectPost.sex),
      callback: function($$v) {
        _vm.$set(_vm.projectPost, "sex", $$v)
      },
      expression: "projectPost.sex"
    }
  }, [_vm._v("女")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    },
    model: {
      value: (_vm.projectPost.sex),
      callback: function($$v) {
        _vm.$set(_vm.projectPost, "sex", $$v)
      },
      expression: "projectPost.sex"
    }
  }, [_vm._v("不限")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "轮休方式:"
    }
  }, [_c('span', [_vm._v("上")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.projectPost.holiday_start),
      callback: function($$v) {
        _vm.$set(_vm.projectPost, "holiday_start", $$v)
      },
      expression: "projectPost.holiday_start"
    }
  }), _vm._v(" "), _c('span', [_vm._v("休")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.projectPost.holiday_end),
      callback: function($$v) {
        _vm.$set(_vm.projectPost, "holiday_end", $$v)
      },
      expression: "projectPost.holiday_end"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否计算出勤率:"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.projectPost.is_calculate),
      callback: function($$v) {
        _vm.$set(_vm.projectPost, "is_calculate", $$v)
      },
      expression: "projectPost.is_calculate"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.projectPost.is_calculate),
      callback: function($$v) {
        _vm.$set(_vm.projectPost, "is_calculate", $$v)
      },
      expression: "projectPost.is_calculate"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实际每日工作时间:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    model: {
      value: (_vm.projectPost.actual_time),
      callback: function($$v) {
        _vm.$set(_vm.projectPost, "actual_time", $$v)
      },
      expression: "projectPost.actual_time"
    }
  })], 1)], 1)], 1)], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-478eb9d6","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/znpb/QyxmGl/QyxmGl_shift.vue
// module id = null
// module chunks = 